import { createFileRoute } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo-head";
import Precos from "@/pages/Precos";

export const Route = createFileRoute("/precos")({
  head: () => buildHead({
    title: "Planos e implantação de CRM com Agentes de IA | OP2P",
    description: "Veja os planos da OP2P: CRM inteligente incluso, Agentes de IA no WhatsApp, voz por IA e tração comercial. Escopo de cada plano e proposta sob medida na demonstração.",
    path: "/precos",
  }),
  component: Precos,
});
